import BuildingIcon from 'components/elements/icons/BuildingIcon'
import BuildingSearchResultIcon from 'components/elements/icons/BuildingSearchResultIcon'
import DestinationIcon from 'components/elements/icons/DestinationIcon'
import RequesterIcon from 'components/elements/icons/RequesterIcon'
import MapTemplate from 'components/templates/MapTemplate'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { DEFAULT_FORWARD_BUTTON_LABEL } from 'constants/label'
import { PAGE_PATH } from 'constants/pagePath'
import { VEHICLE_STATE } from 'constants/qnState'
import { EditingItemContext } from 'contexts/EditingItemContext'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { updateLog } from 'utils/log'
import { StatusProps, success } from 'utils/status'

const TITLE = '搬送先指定画面'

/**
 * QN-03-a: 搬送先確認画面
 */
const TransportDestination: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state, setState } = props
  const [editingItem, setEditingItem] = useContext(EditingItemContext)
  const historyStackContext = useContext(HistoryStackContext)
  const [destinationLocation, setDestinationLocation] = useState(
    editingItem.destinationLocation
  )
  const [isDisabled, setIsDisabled] = useState(false)

  const forwardAction = useCallback((): StatusProps => {
    destinationLocation.isSelected = true
    updateLog(
      TITLE,
      {
        location: state.destinationLocation,
      },
      historyStackContext
    )
    setEditingItem({
      ...editingItem,
      destinationLocation,
    })
    state.confirmationChangeType && setState({ ...state, destinationLocation })
    return success()
  }, [destinationLocation])

  useEffect(() => {
    updateLog(
      TITLE,
      {
        location: state.destinationLocation,
      },
      historyStackContext
    )
  }, [])

  const forwardTo = ((): string => {
    if (state.confirmationChangeType === PAGE_PATH.TRANSPORT_DESTINATION) {
      // 確認画面から搬送先変更で遷移してきた場合は確認画面に戻る
      return PAGE_PATH.CONFIRMATION
    }
    switch (editingItem.vehicleState) {
      case VEHICLE_STATE.ACCIDENT:
        return PAGE_PATH.ACCIDENT
      case VEHICLE_STATE.EMPTY_FUEL:
        return PAGE_PATH.EMPTY_FUEL
      case VEHICLE_STATE.FALLING_WHEEL:
        return PAGE_PATH.FALLING_WHEEL
      case VEHICLE_STATE.ENGINE_TROUBLE:
        return PAGE_PATH.ENGINE_TROUBLE
      case VEHICLE_STATE.FLAT_TIRE:
        return PAGE_PATH.FLAT_TIRE
      case VEHICLE_STATE.LOSS_KEY:
        return PAGE_PATH.LOSS_KEY
      case VEHICLE_STATE.OTHERS:
        return PAGE_PATH.OTHERS
      default:
        return PAGE_PATH.ERROR
    }
  })()

  /** 戻るボタン押下時にeditingItemの中身をqnStateの内容と同期させる */
  const backAction = React.useCallback(() => {
    state.confirmationChangeType &&
      setEditingItem({
        ...editingItem,
        ...state.destinationLocation,
        troubleDatetime: state.troubleDatetime,
        vehicleState: state.vehicleState,
      })
    return success()
  }, [state.confirmationChangeType])

  return (
    <MapTemplate
      title={TITLE}
      usingLocationName
      usingMultiSearch
      location={destinationLocation}
      setLocation={setDestinationLocation}
      setIsDisabled={setIsDisabled}
      fixedMarkers={[
        {
          component: <RequesterIcon />,
          lat: state.location.lat,
          lng: state.location.lng,
        },
      ]}
      markerComponent={<DestinationIcon />}
      searchResultMarkerComponent={<BuildingSearchResultIcon />}
      addressComponent={<BuildingIcon color={CLIENT_SETTINGS.colors.iconCar} />}
      forwardLabel={DEFAULT_FORWARD_BUTTON_LABEL}
      forwardTo={forwardTo}
      forwardAction={forwardAction}
      isDisabled={isDisabled}
      disabledLabel={DEFAULT_FORWARD_BUTTON_LABEL}
      showBack
      backAction={backAction}
      backTo={forwardTo}
      notClearEditingItem
    />
  )
}

export default TransportDestination
